import React from 'react';
import { Calendar, Package, DollarSign, Printer } from 'lucide-react';
import { formatCurrency, formatDate } from '../../utils/formatters';
import { Ordem } from '../../types';
import { Button } from '../Button';
import './styles.css';

interface OrdemCardProps {
  ordem: Ordem;
  onClick: () => void;
  onPrint?: (ordem: Ordem) => void;
}

export const OrdemCard: React.FC<OrdemCardProps> = ({ ordem, onClick, onPrint }) => {
  const pedidosPendentes = ordem.pedidos?.filter(p => p.status === 'pendente').length || 0;
  const pedidosFinalizados = ordem.pedidos?.filter(p => p.status === 'finalizado').length || 0;
  const totalPedidos = ordem.pedidos?.length || 0;

  const handlePrintClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Previne que o onClick do card seja disparado
    if (onPrint) {
      onPrint(ordem);
    }
  };

  return (
    <div
      data-testid={`ordem-card-${ordem.id}`}
      onClick={onClick}
      className="ordem-card fade-in"
    >
      <div className="ordem-card-header">
        <div className="ordem-card-header-content">
          <p className="ordem-card-id">Ordem #{ordem.id}</p>
          <div className="ordem-card-date">
            <Calendar className="icon-calendar" />
            {formatDate(ordem.data)}
          </div>
        </div>
        {onPrint && (
          <Button
            data-testid={`print-card-button-${ordem.id}`}
            onClick={handlePrintClick}
            variant="ghost"
            size="icon"
            className="ordem-card-print-button"
            title="Imprimir ordem de serviço"
          >
            <Printer className="icon-small" />
          </Button>
        )}
      </div>

      <div className="ordem-card-divider"></div>

      <div className="ordem-card-info">
        <div className="ordem-card-info-item">
          <div className="ordem-card-info-label">
            <Package className="icon-package" />
            <span>Total de Pedidos</span>
          </div>
          <span className="ordem-card-info-value">{totalPedidos}</span>
        </div>

        <div className="ordem-card-badges">
          <span className="badge badge-pendente">
            {pedidosPendentes} pendente{pedidosPendentes !== 1 ? 's' : ''}
          </span>
          <span className="badge badge-finalizado">
            {pedidosFinalizados} finalizado{pedidosFinalizados !== 1 ? 's' : ''}
          </span>
        </div>
      </div>

      <div className="ordem-card-footer">
        <div className="ordem-card-footer-content">
          <div className="ordem-card-footer-label">
            <DollarSign className="icon-dollar" />
            <span>Valor Total</span>
          </div>
          <span className="ordem-card-footer-value">
            {formatCurrency(ordem.valor_total)}
          </span>
        </div>
      </div>
    </div>
  );
};

